import { Layout, Popover, List } from 'antd'
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  ArrowLeftOutlined
} from '@ant-design/icons'
// import { Trans } from "@lingui/macro"
import classnames from 'classnames'
// import config from 'config'
import styles from './Header.module.scss'
import { FontAwesomeIcon, Link, Button } from 'components'
import { Menu } from 'config/FeatureFlag'
import { isDoctor } from 'shared/utils/common-utils'
import { connect } from 'react-redux'
import { RootState } from 'store'
import { withRouter } from 'react-router-dom'
import qrcode from "client/assets/images/qrcode.png";
import Logo from "client/assets/images/logo.png";
import { Blog, DoctorLogin, DoctorProfileSetting, DoctorRegister, ForgotPasswords, Homes,  QrcodeInfo,Appointment } from 'config/routersConstants'
import { Usertype } from 'config/UserTypes'
import { QrCodeMenuList } from './QrCodeMenuList'
import { faAngleDown, faPowerOff, faQrcode, faSignInAlt, faUserCog } from '@fortawesome/free-solid-svg-icons'
import { useState } from 'react'
import { logoutAction } from 'reducers/logoutAction'

// const { SubMenu } = Menu

// class Header extends Component<any> {
const Header = (props) => {
  const [isLogoutLoading, setisLogoutLoading] = useState(false)

/*Bug #755 - changed by Aby Joseph on 23 Feb 2022*/
  const logout = () => {
    setisLogoutLoading(true);
    logoutAction().then(() => {
      setisLogoutLoading(false);
      history.push(DoctorLogin.path)
    }).catch(() => {
      setisLogoutLoading(false);
    })
  }
/*Bug #755 - End*/

  const onhandleCloseMenu = () => {
    var root = document.getElementsByTagName("html")[0];
    root.classList.remove("menu-opened");
  };
  // render() {
  const {
    fixed,
    avatar,
    username,
    collapsed,
    notifications,
    onCollapseChange,
    onAllNotificationsRead,
    publicLayout,
    account,
    url,
    location,
    isAuthenticated = true,
    history,
    isMobile
  } = props

  const { pathname: pathnames } = location;

  const leftContent = [
    <div className="main-menu-wrapper" key="12">
      <ul className="main-nav">
        {/* {Menu.HOME.visible &&
          <li className={pathnames === "/" ? "active" : ""}>  <Link to="/">Home</Link></li>
        } */}
        {isAuthenticated ?
          <>
            {Menu.DOCTORS.visible && isDoctor(account) &&
              (<li className={pathnames.startsWith(Usertype[0].user) ? "active" : ""}>
                <Link to={Appointment.path} onClick={() => onhandleCloseMenu()}>Appointments</Link>
              </li>)
            }
            
          </>
          :
          <>
            {Menu.DOCTORS.visible && pathnames.startsWith(Usertype[0].user) &&
              (<li className={pathnames.startsWith(Usertype[0].user) ? "active" : ""}>
                <Link to={DoctorLogin.path} onClick={() => onhandleCloseMenu()}>Appointmnets</Link>
              </li>)
            }
         
          </>


        }
        {
          Menu.BLOG.visible && <li className={pathnames === Blog.path ? "active" : ""}>  <Link to={Blog.path}>Blog</Link></li>
        }

        {isAuthenticated ? (
          <li className="login-link" onClick={() => {
            logoutAction();
            onhandleCloseMenu();
          }}>
            <Link to={DoctorLogin.path }>Logout</Link>
          </li>
        ) : (<li className="login-link" onClick={() => onhandleCloseMenu()}>
          <Link to={DoctorLogin.path}>Log in / Sign up</Link>
        </li>
        )}
      </ul>
    </div>
  ]

  const rightContent = [
    <ul className={!isMobile ? "nav  header-navbar-rht" : "nav"} key="11">
      {isAuthenticated && isDoctor(account) ? (
        <li className={isMobile ? "auth-menu-mobile-item" : "nav-item contact-item"} >
          <Popover
            placement="bottomRight"
            key="notifications"
            className={styles.popOver}
            overlayClassName={styles.notificationPopover}
            getPopupContainer={() => document.querySelector('#primaryLayout')}
            content={
              <div className={styles.notification}>
                <List
                  itemLayout="horizontal"
                  dataSource={QrCodeMenuList}
                  renderItem={(item: any) => (
                    <Link key={item.key} to={item.path} target={item.target} className={styles.notificationItem}>
                      <FontAwesomeIcon icon={faQrcode} className={styles.qrCodeMenuItem} />{item.title}
                    </Link>
                  )}
                />
              </div>
            }
          >
            <FontAwesomeIcon icon={faQrcode} className={styles.qrCode} />
            {/* <img src={qrcode} className="img-fluid btn fontsize20" title="Scan QR-Code" alt="Logo" /> */}
            <FontAwesomeIcon icon={faAngleDown} className={styles.qrArrowDown} />


          </Popover>
        </li>) :
        null}
      {isMobile ?
        <>
          {isAuthenticated ?
            <ul className="nav">
             
              <li>
                <a className="signout_btn" onClick={() => { logoutAction(); history.push(isDoctor(account) ? DoctorLogin.path : Homes.path) }}>
                  <i className="fas fa-power-off fontsize20">
                  </i>
                </a>
              </li>
            </ul>
            :
            <ul className="nav">
              {isMobile  && pathnames !== DoctorLogin.path && !isAuthenticated &&
                <li className="nav-item">
                  <Link to={DoctorLogin.path} id="login_signup_icon">
                    <FontAwesomeIcon icon={faSignInAlt} size='1x' color={'white'} />
                  </Link>
                </li>
              }
            </ul>
          }
        </>
        :
        <ul className="nav header-navbar-rht">

          {!isAuthenticated && pathnames !== QrcodeInfo.path ? (
            <li className="nav-item contact-item" onClick={() => { history.push(QrcodeInfo.path) }}>
              <img src={qrcode} className="img-fluid btn" title="Scan QR code" alt="Logo" />
            </li>) :
            null}

          {isAuthenticated ? (
            <>
              <Link to={DoctorProfileSetting.path} className="profile_icon">
                <FontAwesomeIcon className="profile_icon fontsize20" size={'10x'} icon={faUserCog} />
              </Link>

              <Button shape="circle" loading={isLogoutLoading} className={styles.signoutBtn} onClick={() => logout()} icon={<FontAwesomeIcon className={styles.signoutBtn} size={'10x'} icon={faPowerOff} />} size="large" />

              {/* {isDoctor(account) ? (<li> <a className="profile_icon" href={DoctorProfileSetting.path}><i className="fas fa-user-cog fontsize20 "></i></a></li>)
              : (<li> <a className="profile_icon" href={Profiles.path}><i className="fas fa-user-cog fontsize20 "></i></a></li>)}
                src/components/Layout/Header.tsx
            <li> <a className="signout_btn" onClick={() => { props.logout(); history.push(isDoctor(account) ? DoctorLogin.path : Homes.path) }}><i className="fas fa-power-off fontsize20"></i></a></li> */}

          </>
        ) :

          (
             pathnames !== DoctorRegister.path && pathnames !== ForgotPasswords.path ? (
              <>
                {/* <li>
                <Link to={DoctorLogin.path} className="header-login">
                log in <i className="fas fa-sign-out-alt ml-2"></i> 
                </Link>
                </li> */}
                {/* <li>
                  <AMenu
                    mode="horizontal"
                  >
                    <SubMenu key="SubMenu" className="header-login" title="Log in / Sign up">
                      {LoginMenus.map(login =>
                        <AMenu.Item key={login.to}><Link to={login.to}>{login.label}</Link></AMenu.Item>
                      )}
                    </SubMenu>
                  </AMenu>
                </li> */}
                </>) :
                null
              /**End Bug #456 **/
            )}
        </ul>
      }
    </ul>,
  ]

  // if (config.i18n) {
  // const {languages} = config.i18n
  // const language = getLocale()
  // const currentLanguage = languages.find(
  //   item => item.key === language
  // )

  //   rightContent.unshift(
  //     <Menu
  //       key="language"
  //       selectedKeys={[currentLanguage.key]}
  //       onClick={data => {
  //         setLocale(data.key)
  //       }}
  //       mode="horizontal"
  //     >
  //       <SubMenu title={<Avatar size="small" src={currentLanguage.flag} />}>
  //         {languages.map(item => (
  //           <Menu.Item key={item.key}>
  //             <Avatar
  //               size="small"
  //               style={{ marginRight: 8 }}
  //               src={item.flag}
  //             />
  //             {item.title}
  //           </Menu.Item>
  //         ))}
  //       </SubMenu>
  //     </Menu>
  //   )
  // }

  // rightContent.unshift(
  //   <Popover
  //     placement="bottomRight"
  //     trigger="click"
  //     key="notifications"
  //     overlayClassName={styles.notificationPopover}
  //     getPopupContainer={() => document.querySelector('#primaryLayout')}
  //     content={
  //       <div className={styles.notification}>
  //         {/* <List
  //           itemLayout="horizontal"
  //           dataSource={notifications}
  //           locale={{
  //             emptyText: <Trans>You have viewed all notifications.</Trans>,
  //           }}
  //           renderItem={(item: any) => (
  //             <List.Item className={styles.notificationItem}>
  //               <List.Item.Meta
  //                 title={
  //                   <Ellipsis tooltip lines={1}>
  //                     {item.title}
  //                   </Ellipsis>
  //                 }
  //                 description={moment(item.date).fromNow()}
  //               />
  //               <RightOutlined style={{ fontSize: 10, color: '#ccc' }} />
  //             </List.Item>
  //           )}
  //         /> */}
  //         {notifications?.length ? (
  //           <div
  //             onClick={onAllNotificationsRead}
  //             className={styles.clearButton}
  //           >
  //             {/* <Trans>Clear notifications</Trans> */}Clear notifications
  //           </div>
  //         ) : null}
  //       </div>
  //     }
  //   >
  //     <Badge
  //       count={notifications?.length}
  //       dot
  //       offset={[-10, 10]}
  //       className={styles.iconButton}
  //     >
  //       <BellOutlined className={styles.iconFont} />
  //     </Badge>
  //   </Popover>
  // )

  return (
    <Layout.Header
      className={classnames(styles.header, {
        [styles.fixed]: fixed,
        [styles.collapsed]: collapsed,
        [styles.publicLayout]: publicLayout || !isAuthenticated,
        [styles.isMobile]: isMobile,
      })}
      id="layoutHeader"
    >
      <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>

        {isMobile && pathnames !== Homes.path && !isAuthenticated && <div
          className={styles.button}
          onClick={() => {history.goBack()}}
        >
          <ArrowLeftOutlined />
        </div>}

        {((isMobile && isAuthenticated) || (!publicLayout && isAuthenticated)) && <div
          className={styles.button}
          onClick={() => {onCollapseChange(!collapsed)}}
        >
          {(isMobile && isAuthenticated) || (!publicLayout && isAuthenticated) ? collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined /> : null}
        </div>}
        {(publicLayout || isMobile || !isAuthenticated) &&
          <Link to="/" className="navbar-brand logo" style={isMobile && (publicLayout && !isAuthenticated && pathnames === Homes.path) ? { marginLeft: 18 } : {}}>
            <img src={Logo} className="img-fluid" alt="Logo" />
          </Link>}
        {/* <div>sdfsdfsds</div> */}
        <div className={styles.leftContainer}>{leftContent}</div>
      </div>
      <div className={styles.rightContainer}>{rightContent}</div>
    </Layout.Header>
  )
  // }
}



const mapStateToProps = ({ authentication }: RootState) => ({
  isAuthenticated: authentication.isAuthenticated,
  loginInfo: authentication.loginInfo,
  account: authentication.account,
  loginError: authentication.loginError,
});

type StateProps = ReturnType<typeof mapStateToProps>;

export default connect(mapStateToProps, null)(withRouter(Header));
